module.exports = __webpack_public_path__ + "img/P@2x.e854757.jpg";